/** Leadership Team L10 meeting — rocks on the business plan must match this meeting's rocks page. */
export const LEADERSHIP_L10_MEETING_ID = '99C70006-63AE-46BE-A9D8-E9CBA49A6693'
